import React from "react";
import MaButton from "./ma-button";

const btnSx = {
  bgcolor: "#FFFFFF",
  color: "#374151",
  border: "1px solid #E5E7EB",
  boxShadow: "none",
  minHeight: "40px",
  minWidth: "100px",
  borderRadius: "10px",
  fontWeight: 600,
  fontSize: "13px",
  textTransform: "none",
  "&:hover": {
    bgcolor: "#F9FAFB",
    borderColor: "#D1D5DB",
  },
  "&:disabled": {
    opacity: 0.45,
    color: "#9CA3AF",
  },
};

/**
 * Pagination bar: “Page X of Y” on the left, Previous / Next on the right.
 *
 * @param {number} page — 1-based current page
 * @param {number} totalPages — total pages (clamped to at least 1 for display)
 * @param {(nextPage: number) => void} onPageChange — called with the new 1-based page
 * @param {boolean} [loading] — when true, both buttons are disabled
 * @param {string} [className] — extra classes on the outer wrapper (e.g. border-top, margin)
 */
export function SimplePagination({
  page,
  totalPages,
  onPageChange,
  loading = false,
  className = "",
}) {
  const pages = Math.max(1, Math.floor(Number(totalPages)) || 1);
  const raw = Number(page);
  const current =
    Number.isFinite(raw) && raw >= 1 ? Math.min(Math.floor(raw), pages) : 1;

  const go = (next) => {
    if (loading || next < 1 || next > pages || next === current) return;
    onPageChange?.(next);
  };

  return (
    <div
      className={`flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between ${className}`.trim()}
    >
      <p className="my-0 text-[13px] font-medium tabular-nums text-[#374151]">
        Page {current} of {pages}
      </p>
      <div className="flex shrink-0 gap-2">
        <MaButton
          title="Previous"
          onClick={() => go(current - 1)}
          disabled={loading || current <= 1}
          sx={btnSx}
        />
        <MaButton
          title="Next"
          onClick={() => go(current + 1)}
          disabled={loading || current >= pages}
          sx={btnSx}
        />
      </div>
    </div>
  );
}
